export const subscription = {
  titles: {
    subscription: "Subskrypcja",
    freeTrial: "Okres próbny",
    expired: "Wygasła",
  },

  status: {
    active: "Aktywna",
    canceled: "Anulowana",
    trialAccess: "OKRES PRÓBNY",
    expiredAccess: "DOSTĘP WYGASŁ",
  },

  notices: {
    activeDesc: "Zarządzaj szczegółami subskrypcji i opcjami rozszerzenia planu.",
    canceledDesc:
      "Subskrypcja została anulowana. Dostęp pozostaje aktywny do daty zakończenia.",
    trialDesc: "Ma Pan/Pani dostęp do funkcji systemu do dnia wygaśnięcia.",
    expiredDesc:
      "Okres próbny dobiegł końca. Wykup subskrypcję, aby dalej korzystać z usługi.",
    upgradeHint:
      "Nie trać dostępu do zaawansowanych funkcji, rozszerz subskrypcję już teraz",
    expiredHint:
      "Dostęp wygasł. Wykup subskrypcję, aby dalej korzystać ze wszystkich funkcji",
    needFullAccess: "Potrzebny pełny dostęp?",
    choosePlan: "Wybierz plan dopasowany do siebie",
  },

  labels: {
    planActive: "Aktywny plan",
    stateNow: "Obecny status",
    trialPeriod: "Okres próbny",
    periodExpired: "Okres zakończony",
    summary: "Podsumowanie subskrypcji",
    timeLeft: "Pozostały czas",
    trialExpiresIn: "Bezpłatny okres próbny kończy się za {days} dni",
    expirationDate: "Data wygaśnięcia",
    nextRenewal: "Następne odnowienie",
    accessUntil: "Dostęp aktywny do",
    perUnit: "/ {unit}",
    unitRoom: "Pokój",
    unitRoomMultiple: "Wiele pokoi",
    unitApartment: "Apartament",
    unitVilla: "Willa",
    unitCamping: "Kemping",
    unitLodging: "Nocleg",
    annualPlan: "Plan roczny",
    monthlyPlan: "Plan miesięczny",
  },

  actions: {
    addUnit: "Dodaj: {unitLabel}",
    manageSubAndPayment: "Zarządzaj subskrypcją i sposobem płatności",
    processing: "Przetwarzanie...",
    subscribeNow: "Wykup subskrypcję",
    chooseAPlan: "Wybierz plan",
    goToSubscriptionPage: "Przejdź do planów",
  },

  confirmCancel: {
    title: "Anulować subskrypcję?",
    text: "Po anulowaniu utracisz dostęp do swoich usług.",
    confirm: "Tak, anuluj",
    cancel: "Nie",
  },

  formats: {
    priceTotalHTML: "{price}",
    dateDDMMYYYY: "{date}",
  },

  modal: {
    title: 'Subskrypcja aktywna!',
    details: "Szczegóły subskrypcji",
    welcomeTitle: "Witamy w WA Checkin {plan}!",
    welcomeBody:
      "Od teraz ma Pan/Pani pełny dostęp do naszych narzędzi do check-inu przez WhatsApp, synchronizacji z OTA, chatbota AI, automatyzacji i wielu innych funkcji.",
    feature1: {
      title: "Zarządzaj taryfami i dostępnością",
      desc: "Wygodnie zmieniaj ceny i kontroluj obłożenie w czasie rzeczywistym, wszystko w jednym miejscu.",
    },
    feature2: {
      title: "Zdobywaj rezerwacje bezpośrednie",
      desc: "Goście mogą rezerwować bezpośrednio na Twojej stronie, bez pośrednictwa OTA.",
    },
    schedule: {
      help: "Umów bezpłatną rozmowę wideo, a pomożemy wszystko skonfigurować.",
      cta: "Umów rozmowę wideo",
    },
  },

  sectionPlans: {
    title: "Lista planów",
    confirm: {
      header: "Potwierdź zmianę planu",
      loadingMsg: "Trwa aktualizacja planu, prosimy o chwilę cierpliwości.",
      body: "Za chwilę plan konta zostanie zmieniony na: {plan}.",
    },
    actions: {
      cancel: "Anuluj",
      confirmUpgrade: "Potwierdź zmianę",
      goToBilling: "Przejdź do sposobów płatności",
      accept: "OK",
      updateSubscription: "Zaktualizuj subskrypcję", // NEW
    },
    success: {
      title: "Gotowe",
      body: "Subskrypcja została zaktualizowana.",
    },
    errors: {
      processTitle: "Błąd przetwarzania żądania",
      unknownUpdate: "Nieznany błąd podczas aktualizacji subskrypcji.",
      genericTitle: "Błąd",
      genericBody: "Nie udało się zaktualizować subskrypcji.",
    },
  },

  plans: {
    features: {
      installation: "Indywidualne wdrożenie z ekspertem",
      fastSupport: "Szybkie wsparcie przez e-mail, czat i telefon",
      whatsappCheckin: "Check-in przez WhatsApp",
      linkEmailCheckin: "Check-in przez link lub e-mail",
      welcomeMessage: "Wiadomość powitalna przez WhatsApp i e-mail",
      digitalSignature: "Cyfrowy podpis regulaminu",
      idScanner: "Skaner dowodu i paszportu",
      sesHospedajesSend: "Automatyczne przesyłanie raportów do służb",
      reviewLink: "Wysyłka linku do opinii Google po check-oucie",
      smartLocks: "Połączenie z inteligentnymi zamkami",
      channelManager1: "Channel manager (połączenie z 1 OTA)",

      includesLite: "Wszystko z planu Lite",
      selfieVerification: "Weryfikacja gościa przy check-inie za pomocą selfie",
      unifiedInbox: "Wspólna skrzynka odbiorcza",
      upsellServices: "Oferowanie usług i atrakcji przez WhatsApp",
      paymentLinks: "Obciążanie gości (link do płatności kartą)",
      websiteBookings: "Strona rezerwacyjna z zsynchronizowanym kalendarzem",
      channelManagerUnified: "Channel manager (wspólne kalendarze, ponad 100 OTA)",
      channelManagerCentralPrices:
        "Channel manager (centralne zarządzanie cenami)",
      guestSupportOption: "Możliwość wykupienia obsługi gości",

      includesStandard: "Wszystko z planu Standard",
      centralizedPriceManager: "Centralny menedżer cen",
      aiChatbot: "Chatbot AI na WhatsApp (FAQ i automatyzacja)",
      googleVacationRentals: "Integracja z Google Vacation Rentals",
      whatsappReminders: "Przypomnienia dla gości na WhatsApp",
      eInvoicingSoon: "Faktury elektroniczne (wkrótce)",
      prioritySupport: "Wsparcie priorytetowe",
    },
  },

  planCard: {
    perSlash: "/za", // separator "/per {unit}"
    infoTitle: "Szczegóły planu",
    update: "Zaktualizuj",
    subscribe: "Wykup",
    currentPlan: "Obecny plan",
    byApartment: "za apartament",
    byVilla: "za willę",
    byCamping: "za kemping",
    byRoom: "za pokój",
    byUnit: "za jednostkę",
  },

  services: {
    title: "Usługi dodatkowe",
    ctaComingSoon: "Wkrótce",
    guestSupport: {
      title: "Obsługa gości",
      subtitle: "Zajmujemy się za Pana/Panią rozmowami na WhatsApp i telefonami od gości.",
      desc: "Pomagamy im w check-inie, odpowiadamy na pytania, a także obsługujemy telefony w sprawie rezerwacji bezpośrednich. Pan/Pani odpoczywa, a goście dostają obsługę na 10/10 od pierwszego kontaktu.",
    },
    chatbot: {
      title: "ChatBot AI",
      activeService: "Usługa aktywna",
      desc: "Dodaj usługę chatbota AI i obsługuj zapytania gości szybko oraz sprawnie.",
      activateCta: "Aktywuj usługę",
      confirm: {
        header: "Potwierdź aktywację",
        loadingMsg: "Trwa aktywacja usługi ChatBot, prosimy o chwilę cierpliwości.",
        body: "Za chwilę usługa ChatBot AI zostanie aktywowana dla Pana/Pani obiektów. Liczba obiektów: {units}.",
      },
      discount: {
        applied: "Zastosowany rabat:",
        couponFallback: "Kupon",
      },
      pricing: {
        unitPrice: "Cena jednostkowa:",
        quantity: "Ilość:",
        totalToPay: "Razem do zapłaty:",
      },
    },
  },

  invoices: {
    title: "Faktury i rachunki",
    created: "Utworzono",
    status: "Status",
    amount: "Kwota",
    paid: "Zapłacona",
    unpaid: "Niezapłacona",
    viewInvoice: "Zobacz fakturę",
    empty: "Nie masz jeszcze żadnych faktur.",
  },

  updateModal: {
    header: "Dodaj jednostki: {unitLabel}",
    body: "Podaj, ile jednostek dodać do subskrypcji: {unitLabelPlural}.",
    pricing: {
      discountApplied: "Rabat zastosowany do subskrypcji:",
      unitPrice: "Cena jednostkowa:",
      quantity: "Ilość:",
      totalNewUnits: "Razem za nowe jednostki:",
      newSubscriptionTotal: "Nowa łączna wartość subskrypcji:",
    },
    prorationNote:
      "Zmiany subskrypcji są rozliczane proporcjonalnie do dni pozostałych w bieżącym okresie. Pełna opłata zostanie naliczona w przyszłym miesiącu.",
  },

  page: {
    findRightPlan: "Znajdź plan dopasowany do siebie",
    enterAmount: "Podaj liczbę",
    numberOf: "Liczba jednostek: {unit}"
  },
  billing: {
    title: "Wybierz okres rozliczeniowy",
    subtitle: "Wybierz sposób płatności",
    monthly: "Miesięcznie",
    annual: "Rocznie",
    discountShort: "−{percent}%",
  },
};
